import React from 'react';
import ShipmentInfoTable from '../../components/tables/ShipmentInfoTable/ShipmentInfoTable';
import { Container } from 'react-bootstrap';

const ShipmentInfo = () => {
    return (
        <Container fluid className="mt-5">
            <h2>Shipment Information</h2>
            <ShipmentInfoTable />
        </Container>
    );
};

export default ShipmentInfo;
